import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} informado na túa zona",
  "alert.toast.escalation": "O {hazard} próximo agravouse",
  "alert.toast.inPath": "O {hazard} avanza cara á túa localización",
  "alert.toast.allClear": "Situación normalizada preto de {place}",
  "alert.toast.tap": "Abre para consultar os detalles e as medidas de seguridade",
  "alert.takeover.title": "{hazard} — é necesaria a acción inmediata",
  "alert.takeover.details": "Ver o informe completo",
  "now.status.allClear": "Non hai perigos activos.",
  "now.status.stayAware": "Mantéñase en alerta.",
  "now.status.sub.allClear": "Non hai perigos activos dentro do teu radio de vixilancia.",
  "now.activity.empty": "Non se rexistrou actividade na zona.",
  "onboarding.promise.tagline": "Unha rede comunitaria de alerta temperá.",
  "onboarding.promise.continue": "Comezar",
  "region.unsupported.title": "Localización fóra da área de cobertura",
  "you.voice.intro": "Escolle o ton co que Beacon se comunica.",
};
